import React, { useState, useRef, useEffect } from "react";
import { fetchWrapper } from "../helpers/fetchwrapper";

import i18n from "i18next";
import { baseUrl } from "../helpers/constants";
import { ISachwert } from "../Models/ISachwert";
import {
  Text,
  createTableColumn,
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Subtitle2,
  TableColumnDefinition,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@fluentui/react-components";

interface ILuebArticleDetailsDialogProps {
  artikelId: string;
  benennungDE: string;
  benennungEN: string;
  isDialogOpen?: boolean;
  onClose(): void;
}

function LuebArticleDetailsDialog(props: ILuebArticleDetailsDialogProps) {
  const [sachwerte, setSachwerte] = useState<ISachwert[]>([]);
  const [loading, setLoading] = useState(true);

  const columns: TableColumnDefinition<ISachwert>[] = [
    // ------------Artikel------------
    createTableColumn<ISachwert>({
      columnId: "nameDE",
      renderHeaderCell: () => {
        return <Subtitle2> {i18n.t<string>("eigenschaft")}</Subtitle2>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {" "}
            {i18n.language.includes("de") ? item.nameDE : item.nameEN}
          </Text>
        );
      },
    }),
    createTableColumn<ISachwert>({
      columnId: "wert",
      renderHeaderCell: () => {
        return <Subtitle2> {i18n.t<string>("wert")}</Subtitle2>;
      },
      renderCell: (item) => {
        let wert;
        if (item.typ == "NUMBER") {
          wert = parseFloat(item.wert).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          });
        } else {
          wert = i18n.language.includes("de") ? item.wertDE : item.wertEN;
        }
        return (
          <div>
            <Text>{wert}</Text>
          </div>
        );
      },
    }),

    createTableColumn<ISachwert>({
      columnId: "mengeneinheit",
      renderHeaderCell: () => {
        return <Subtitle2> {i18n.t<string>("mengeneinheit")}</Subtitle2>;
      },
      renderCell: (item) => {
        let wert;
        if (item.typ == "NUMBER") {
          wert = parseFloat(item.wert).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          });
        } else {
          wert = i18n.language.includes("de") ? item.wertDE : item.wertEN;
        }
        return (
          <div>
            <Text>{item.mengeneinheit}</Text>
          </div>
        );
      },
    }),
  ];

  const getSachwerte = () => {
    if (props.artikelId) {
      fetchWrapper
        .postWithAuth(`${baseUrl}/api/sachwert/byquery`, {
          artikelId: props.artikelId,
        })
        .then((result: ISachwert[]) => {
          setLoading(false);
          setSachwerte(result);
        });
    }
  };

  useEffect(() => {
    if (props.artikelId != "") {
      getSachwerte();
    }
  }, [props.artikelId]);

  const refContentDiv = useRef<HTMLHeadingElement>(null);
  useEffect(() => {}, [refContentDiv.current]);

  return (
    <>
      <Dialog open={props.isDialogOpen}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>
              {i18n.t<string>("technicalData")}
              <br></br>
              <div
                style={{
                  fontWeight: "200",
                  fontSize: "medium",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {props.artikelId}
                <div style={{ color: "#ff6600" }}>&nbsp;{"/"}&nbsp;</div>
                {i18n.language.includes("de")
                  ? props.benennungDE
                  : props.benennungEN}
              </div>
            </DialogTitle>
            <DialogContent>
              <DataGrid items={sachwerte} columns={columns}>
                <DataGridHeader>
                  <DataGridRow>
                    {({ renderHeaderCell }) => (
                      <DataGridHeaderCell>
                        {renderHeaderCell()}
                      </DataGridHeaderCell>
                    )}
                  </DataGridRow>
                </DataGridHeader>
                <DataGridBody<ISachwert[]>>
                  {({ item, rowId }) => (
                    <DataGridRow<ISachwert[]> key={rowId}>
                      {({ renderCell }) => (
                        <DataGridCell>{renderCell(item)}</DataGridCell>
                      )}
                    </DataGridRow>
                  )}
                </DataGridBody>
              </DataGrid>
            </DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                onClick={() => {
                  props.onClose();
                }}
              >
                {i18n.t<string>("close")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
}

export default LuebArticleDetailsDialog;
